// components/TimeOnlyPicker.tsx
import moment from "moment";
import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import {
  FieldError,
  useForm,
  UseFormRegister,
  Control,
  Controller,
} from "react-hook-form";

interface TimeOnlyPickerProps {
  name: string;
  control: Control<any>;
  error?: FieldError;
  disabled?: boolean;
  placeholder?: string;
  validationRules?: object;
}

const TimeOnlyPicker = ({
  name,
  control,
  error,
  disabled,
  placeholder,
  validationRules,
}: TimeOnlyPickerProps) => {
  const [time, setTime] = useState<Date | null>(null);

  return (
    <div className="flex flex-col gap-1 w-full">
      <Controller
        name={name}
        control={control}
        rules={validationRules}
        render={({ field: { onChange, value } }) => {
          const timeValue = moment(value, "HH:mm").isValid()
            ? moment(value, "HH:mm").toDate()
            : null;
          return (
            <DatePicker
              selected={timeValue}
              onChange={(date: Date | null) => {
                if (date) {
                  const formattedTime = moment(date).format("HH:mm"); // or "hh:mm A" for AM/PM
                  onChange(formattedTime); // Save as string: "13:00" or "01:00 PM"
                } else {
                  onChange(null);
                }
              }}
              showTimeSelect
              showTimeSelectOnly
              timeIntervals={15}
              timeCaption="Time"
              dateFormat="h:mm aa"
              placeholderText={placeholder}
              disabled={disabled}
              className={`h-7 w-full border px-1 py-1 text-xs shadow-theme-xs placeholder:text-gray-400 focus:outline-none focus:ring bg-transparent text-gray-800 border-gray-300 focus:border-brand-300 focus:ring focus:ring-brand-500/10 ${
                error ? "border-red-500" : ""
              }`}
            />
          );
        }}
      />
      {error && <span className="text-xs text-red-500">{error.message}</span>}
    </div>
  );
};

export default TimeOnlyPicker;

// import { useState, useRef, useEffect } from "react";
// import { FieldError, useForm, UseFormRegister } from "react-hook-form";

// interface MyInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
//   name: string;
//   register: UseFormRegister<any>;
//   error?: FieldError;
//   validationRules?: object;
// }

// export default function CustomTimePicker({
//   name,
//   register,
//   error,
//   validationRules,
//   ...rest
// }: MyInputProps) {
//   const [showOptions, setShowOptions] = useState(false);
//   const [selectedTime, setSelectedTime] = useState("");
//   const dropdownRef = useRef<HTMLDivElement | null>(null);

//   const times = Array.from({ length: 24 * 2 }, (_, i) => {
//     const hour = Math.floor(i / 2);
//     const minute = i % 2 === 0 ? "00" : "30";
//     return `${String(hour).padStart(2, "0")}:${minute}`;
//   });

//   const handleTimeSelect = (time: any) => {
//     setSelectedTime(time);
//     setShowOptions(false);
//   };

//   useEffect(() => {
//     const handleClickOutside = (e: any) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
//         setShowOptions(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   return (
//     <>
//       <div className="relative" ref={dropdownRef}>
//         <input
//           readOnly
//           type="text"
//           value={selectedTime}
//           onClick={() => setShowOptions((prev) => !prev)}
//           {...register(name, validationRules)}
//           {...rest}
//           className="h-7 w-full border px-4 py-1 text-xs shadow-theme-xs placeholder:text-gray-400 focus:outline-none focus:ring bg-transparent text-gray-800 border-gray-300 focus:border-brand-300 focus:ring focus:ring-brand-500/10"
//         />

//         {showOptions && (
//           <div className="absolute z-10 mt-1 w-full max-h-60 overflow-y-auto border border-gray-300 rounded-lg shadow bg-white">
//             {times.map((time) => (
//               <div
//                 key={time}
//                 onClick={() => handleTimeSelect(time)}
//                 className="px-4 py-2 text-sm hover:bg-blue-100 cursor-pointer"
//               >
//                 {time}
//               </div>
//             ))}
//           </div>
//         )}
//       </div>
//     </>
//   );
// }
